import * as React from 'react';
import { StatusCodes } from '@constants/enum/common';
import {
  IMessage,
  IPipeline,
  ISearchResult,
  ISearchResultAnswer,
  ISearchResultDocument,
} from '@redux/types/types';
import SearchNoResultsContainer from '../results/SearchNoResultsContainer';
import SearchResultsContainer from '../results/SearchResultsContainer';

type BodyProps = {
  isExternal?: boolean;
  searchResult: ISearchResult | null;
  searchStatus: StatusCodes;
  selectedPipelineName?: string;
  selectedPipeline?: IPipeline;
  displayResultsFileOptions: boolean;
  displayResultsMoreOptions: boolean;
  displayFeedbackOptions: boolean;
  answers: ISearchResultAnswer[];
  documents: ISearchResultDocument[];
  query: string;
  message?: IMessage;
  activatePipeline: (_: string) => Promise<void>;
};

const RenderBody: React.FC<BodyProps> = ({
  isExternal,
  searchResult,
  searchStatus,
  selectedPipelineName,
  selectedPipeline,
  displayResultsFileOptions,
  displayResultsMoreOptions,
  displayFeedbackOptions,
  answers,
  documents,
  query,
  message,
  activatePipeline,
}) => {
  if (answers.length || documents.length) {
    return (
      <SearchResultsContainer
        isExternal={isExternal}
        results={searchResult!}
        status={searchStatus}
        query={query}
        pipelineName={selectedPipelineName || ''}
        pipelineId={selectedPipeline?.pipeline_id || ''}
        displayFileOptions={displayResultsFileOptions}
        displayMoreOptions={displayResultsMoreOptions}
        displayFeedbackOptions={displayFeedbackOptions}
      />
    );
  }

  return (
    <SearchNoResultsContainer
      selectedPipeline={selectedPipeline}
      status={searchStatus}
      query={query}
      isExternal={isExternal}
      message={message}
      onActivatePipeline={() => activatePipeline(selectedPipelineName!)}
    />
  );
};

export default React.memo(RenderBody);
